import { combineReducers } from 'redux';
import commonSlice from './CommonSlice';

const RootReducer = combineReducers({
  common: commonSlice.reducer,
});

export default RootReducer;
